const gobalization = (locale: string, brand?: string) => {
    switch (locale) {
        case "en-us":
            switch (brand) {
                case "MSI":
                    return {
                        shipFrom: {
                            line1: "425-445 S Lemon Ave",
                            city: "City of Industry",
                            countrySubdivision: "CA",
                            postalCode: "91748",
                            country: "US",
                            countryName: "United States"
                        },
                        locale: "en_US",
                        currency: "USD",
                    }
                case "ASUS":
                    return {
                        shipFrom: {
                            line1: "18120 Bishop Avenue",
                            city: "Carson",
                            countrySubdivision: "CA",
                            postalCode: "90746",
                            country: "US",
                            countryName: "United States"
                        },
                        locale: "en_US",
                        currency: "USD",
                    }
                default:
                    return {
                        shipFrom: {
                            line1: "2530 Zanker Rd",
                            city: "San Jose",
                            countrySubdivision: "CA",
                            postalCode: "95131",
                            country: "US",
                            countryName: "United States"
                        },
                        locale: "en_US",
                        currency: "USD",
                    }
            }
        case "en-ca":
            return {
                shipFrom: {
                    line1: "2530 Zanker Rd",
                    city: "San Jose",
                    countrySubdivision: "CA",
                    postalCode: "95131",
                    country: "US",
                    countryName: "United States"
                },
                locale: "en_CA",
                currency: "CAD"
            }
        case "en-au":
            return {
                shipFrom: {
                    line1: "U 1/56 Pirrama Rd",
                    city: "Pyrmont",
                    countrySubdivision: "New South Wales",
                    postalCode: "2009",
                    country: "AU",
                    countryName: "Australia"
                },
                locale: "en_AU",
                currency: "AUD"
            }
        case "en-sg":
            return {
                shipFrom: {
                    line1: "130 Cantonment Road",
                    city: "Singapore",
                    countrySubdivision: "",
                    postalCode: "089775",
                    country: "SG",
                    countryName: "Singapore"
                },
                locale: "en_SG",
                currency: "SGD"
            }
        case "en-eu":
            return {
                shipFrom: {
                    line1: "Z.I. de la Maladière",
                    city: "Cluses",
                    countrySubdivision: "",
                    postalCode: "74300",
                    country: "FR",
                    countryName: "France"
                },
                locale: "en_EU",
                currency: "EUR"
            }
        case "en-af":
            return {
                shipFrom: {
                    line1: "123 Market Street",
                    city: "Nairobi",
                    countrySubdivision: "Nairobi County",
                    postalCode: "00100",
                    country: "KE",
                    countryName: "Kenya"
                },
                locale: "en_EU",
                currency: "EUR"
            }
        case "en-gb":
            return {
                shipFrom: {
                    line1: "25-28 Enterprise Park",
                    city: "Bolton",
                    postalCode: "BL6 6PE",
                    countrySubdivision: "",
                    country: "GB",
                    countryName: "United Kingdom"
                },
                locale: "en_GB",
                currency: "GBP"
            }
        case "de-de":
            return {
                shipFrom: {
                    line1: "Z.I. de la Maladière",
                    city: "Cluses",
                    countrySubdivision: "",
                    postalCode: "74300",
                    country: "FR",
                    countryName: "France"
                },
                locale: "de_DE",
                currency: "EUR"
            }
        case "fr-fr":
            return {
                shipFrom: {
                    line1: "Z.I. de la Maladière",
                    city: "Cluses",
                    countrySubdivision: "",
                    postalCode: "74300",
                    country: "FR",
                    countryName: "France"
                },
                locale: "fr_FR",
                currency: "EUR"
            }
        case "es-la":
            return {
                shipFrom: {
                    "line1": "Avenida Central, Calle 5",
                    "city": "San José",
                    "state": "San José",
                    "postalCode": "10101",
                    "country": "CR",
                    "countryName": "Costa Rica"
                },
                locale: "es_LA",
                currency: "USD"
            }
        case "es-es":
            return {
                shipFrom: {
                    line1: "Z.I. de la Maladière",
                    city: "Cluses",
                    countrySubdivision: "",
                    postalCode: "74300",
                    country: "FR",
                    countryName: "France"
                },
                locale: "es_ES",
                currency: "EUR"
            }
        case "it-it":
            return {
                shipFrom: {
                    line1: "Z.I. de la Maladière",
                    city: "Cluses",
                    countrySubdivision: "",
                    postalCode: "74300",
                    country: "FR",
                    countryName: "France"
                },
                locale: "it_IT",
                currency: "EUR"
            }
        case "ja-jp":
            return {
                shipFrom: {
                    line1: "2530 Zanker Rd",
                    city: "San Jose",
                    countrySubdivision: "CA",
                    postalCode: "95131",
                    country: "US",
                    countryName: "United States"
                },
                locale: "ja_JP",
                currency: "JPY"
            }
        case "zh-tw":
            return {
                shipFrom: {
                    line1: "5F, No.154, An-Der St.",
                    city: "Taipei",
                    countrySubdivision: "TW",
                    postalCode: "100",
                    country: "TW",
                    countryName: "Taiwan"
                },
                locale: "zh_TW",
                currency: "TWD"
            }
        case "vi-vn":
            return {
                shipFrom: {
                    line1: "12 Le Loi Street, Ben Nghe Ward",
                    city: "Ho Chi Minh",
                    countrySubdivision: "",
                    postalCode: "70000",
                    country: "VN",
                    countryName: "Vietnam"
                },
                locale: "vi_VN",
                currency: "VND"
            }
        case "ko-kr":
            return {
                shipFrom: {
                    "line1": "서울특별시 강남구 테헤란로 152",
                    "city": "서울",
                    "countrySubdivision": "",
                    "postalCode": "06236",
                    "country": "KR",
                    "countryName": "대한민국"
                },
                locale: "ko_KR",
                currency: "KRW"
            }
        case "es-mx":
            return {
                shipFrom: {
                    "line1": "Av. Paseo de la Reforma 305, Colonia Cuauhtémoc",
                    "city": "Mexico City",
                    "countrySubdivision": "EM",
                    "postalCode": "06500",
                    "country": "MX",
                    "countryName": "Mexico"
                },
                locale: "es_MX",
                currency: "MXN"
            }
        case "pt-br":
            return {
                shipFrom: {
                    "line1": "Avenida Paulista, 1578, Bela Vista",
                    "city": "São Paulo",
                    "countrySubdivision": "SP",
                    "postalCode": "01310-200",
                    "country": "BR",
                    "countryName": "Brazil"
                },
                locale: "pt_BR",
                currency: "BRL"
            }
        case "en-me":
            return {
                shipFrom: {
                    "line1": "Sheikh Zayed Road, Trade Centre 1",
                    "city": "Dubai",
                    "countrySubdivision": "Dubai",
                    "postalCode": "",
                    "country": "AE",
                    "countryName": "United Arab Emirates"
                },
                locale: "en_ME",
                currency: "USD"
            }
        case "en-hk":
            return {
                shipFrom: {
                    "line1": "8 Finance Street, Central",
                    "city": "Hong Kong",
                    "countrySubdivision": "Hong Kong Island",
                    "postalCode": "",
                    "country": "HK",
                    "countryName": "Hong Kong SAR"
                },
                locale: "en_HK",
                currency: "HKD"
            }
        case "en-ph":
            return {
                shipFrom: {
                    "line1": "123 Ayala Avenue, Barangay San Lorenzo",
                    "city": "Makati",
                    "countrySubdivision": "Metro Manila",
                    "postalCode": "1223",
                    "country": "PH",
                    "countryName": "Philippines"
                },
                locale: "en_PH",
                currency: "PHP"
            }
        case "nb-no":
            return {
                shipFrom: {
                    line1: "Z.I. de la Maladière",
                    city: "Cluses",
                    countrySubdivision: "",
                    postalCode: "74300",
                    country: "FR",
                    countryName: "France"
                },
                locale: "nb_NO",
                currency: "NOK"
            }
        case "pl-pl":
            return {
                shipFrom: {
                    line1: "Z.I. de la Maladière",
                    city: "Cluses",
                    countrySubdivision: "",
                    postalCode: "74300",
                    country: "FR",
                    countryName: "France"
                },
                locale: "pl_PL",
                currency: "PLN"
            }
        case "nl-nl":
            return {
                shipFrom: {
                    line1: "Z.I. de la Maladière",
                    city: "Cluses",
                    countrySubdivision: "",
                    postalCode: "74300",
                    country: "FR",
                    countryName: "France"
                },
                locale: "nl_NL",
                currency: "EUR"
            }
        default:
            return {
                shipFrom: {
                    line1: "2530 Zanker Rd",
                    city: "San Jose",
                    countrySubdivision: "CA",
                    postalCode: "95131",
                    country: "US",
                    countryName: "United States"
                },
                locale: "en_US",
                currency: "USD",
            }
    }
}
export default gobalization;